import { InputHTMLAttributes, forwardRef } from 'react';

import clsx from 'clsx';

import { Label } from './label';

type RadioGroupInputProps = InputHTMLAttributes<HTMLInputElement> & {
  id: string;
  label: string;
};

export const RadioGroupOption = forwardRef<HTMLInputElement, RadioGroupInputProps>((props, ref) => {
  const { id, label, className, ...rest } = props;

  return (
    <div className={clsx('inline-flex-full-center gap-2', className)}>
      <label className="relative flex items-center cursor-pointer select-none">
        <input
          {...rest}
          ref={ref}
          id={id}
          type="radio"
          className="appearance-none p-1 w-5 h-5 border border-background rounded-full focus:outline-none focus:ring-2 focus:ring-accent transition-colors duration-200 group checked:bg-primary checked:border-secondary"
        />
        <span className="absolute left-0.5 top-0.5 w-4 h-4 rounded-full pointer-events-none border border-secondary flex items-center justify-center" />
      </label>
      <Label htmlFor={id} className="font-medium text-gray-500">
        {label}
      </Label>
    </div>
  );
});

RadioGroupOption.displayName = 'RadioGroupOption';
